import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({
  productId,
  image,
  name,
  description,
  price,
  priceLabel,
  onAddToCart,
  isInCart = false,
  className = '',
  detailsUrl,
  ...rest
}) => {
  const [quantity, setQuantity] = useState(1);

  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleIncrement = () => {
    setQuantity(quantity + 1);
  };

  const handleAddToCart = () => {
    onAddToCart(productId, quantity);
  };

  return (
    <article className={`product-card ${className}`.trim()} {...rest}>
      <div className="product-card__image">
        {image ? (
          detailsUrl ? (
            <Link to={detailsUrl} style={{ display: 'block' }}>
              <img src={image} alt={name} loading="lazy" style={{ cursor: 'pointer' }} />
            </Link>
          ) : (
            <img src={image} alt={name} loading="lazy" />
          )
        ) : (
          <div className="product-card__placeholder">
            <i className="far fa-image" aria-hidden="true"></i>
          </div>
        )}
      </div>

      <div className="product-card__details">
        <h3 className="product-card__name">{name}</h3>
        {description && <p className="product-card__description">{description}</p>}

        <div className="product-card__quantity">
          <span className="product-card__quantity-label">Qty</span>
          <div className="product-card__quantity-controls">
            <button
              type="button"
              className="product-card__qty-btn"
              onClick={handleDecrement}
              aria-label="Decrease quantity"
            >
              -
            </button>
            <input
              type="number"
              className="product-card__qty-input"
              value={quantity}
              onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
              min="1"
              aria-label="Quantity"
            />
            <button
              type="button"
              className="product-card__qty-btn"
              onClick={handleIncrement}
              aria-label="Increase quantity"
            >
              +
            </button>
          </div>
        </div>

        <div className="product-card__actions">
          <div className="product-card__price">{priceLabel} {price}</div>
          <button
            type="button"
            className="product-card__add-btn"
            onClick={handleAddToCart}
          >
            <i className="fas fa-shopping-bag" aria-hidden="true"></i>
            {isInCart ? 'Add More' : 'Add Cart'}
          </button>
        </div>
      </div>
    </article>
  );
};

ProductCard.propTypes = {
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  image: PropTypes.string,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  price: PropTypes.string.isRequired,
  priceLabel: PropTypes.string,
  onAddToCart: PropTypes.func,
  isInCart: PropTypes.bool,
  className: PropTypes.string,
  detailsUrl: PropTypes.string,
};

ProductCard.defaultProps = {
  image: '',
  description: '',
  priceLabel: 'INR',
  onAddToCart: () => {},
  isInCart: false,
  className: '',
  detailsUrl: '',
};

export default ProductCard;

